import React from 'react';
import './molecules.css';

interface WaitingScreenProps {
  userEmail?: string;
  onLogout?: () => void;
}

export const WaitingScreen: React.FC<WaitingScreenProps> = ({
  userEmail,
  onLogout,
}) => {
  return (
    <div className="min-h-screen relative overflow-hidden bg-[#8A9A9E]">
      {/* Molecule clusters */}

      {/* Top left — Zigzag */}
      <div className="mol" style={{position:'absolute',top:50,left:50,pointerEvents:'none'}}>
        <svg width="80" height="70" viewBox="-30 -10 110 70" fill="none">
          <circle cx="0" cy="0" r="4" fill="#fff"/>
          <circle cx="40" cy="30" r="5" fill="#fff"/>
          <circle cx="0" cy="50" r="4" fill="#fff"/>
          <line x1="0" y1="0" x2="40" y2="30" stroke="#fff" strokeWidth="2"/>
          <line x1="40" y1="30" x2="0" y2="50" stroke="#fff" strokeWidth="2"/>
          <path d="M-4,0 Q-14,-10 -24,0 Q-34,-10 -44,0" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Top right — Triangle */}
      <div className="mol-d1" style={{position:'absolute',top:80,right:50,pointerEvents:'none'}}>
        <svg width="70" height="65" viewBox="-5 -10 100 75" fill="none">
          <circle cx="0" cy="0" r="4" fill="#fff"/>
          <circle cx="50" cy="0" r="4" fill="#fff"/>
          <circle cx="25" cy="45" r="5" fill="#fff"/>
          <line x1="0" y1="0" x2="50" y2="0" stroke="#fff" strokeWidth="2"/>
          <line x1="0" y1="0" x2="25" y2="45" stroke="#fff" strokeWidth="2"/>
          <line x1="50" y1="0" x2="25" y2="45" stroke="#fff" strokeWidth="2"/>
          <path d="M54,0 Q64,-10 74,0 Q84,-10 94,0" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Bottom center — Horizontal pair */}
      <div className="mol-d2" style={{position:'absolute',bottom:55,left:'50%',transform:'translateX(-50%)',pointerEvents:'none'}}>
        <svg width="120" height="30" viewBox="-50 -15 170 30" fill="none">
          <circle cx="0" cy="0" r="4" fill="#fff"/>
          <circle cx="50" cy="0" r="4" fill="#fff"/>
          <line x1="0" y1="0" x2="50" y2="0" stroke="#fff" strokeWidth="2"/>
          <path d="M-4,0 Q-14,-10 -24,0 Q-34,-10 -44,0" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
          <path d="M54,0 Q64,10 74,0 Q84,10 94,0" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-7 text-center">
        {/* Clock icon */}
        <div className="w-[72px] h-[72px] bg-white/25 rounded-[20px] flex items-center justify-center mb-6">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#1A1814" strokeWidth="1.5"/>
            <path d="M12 6v6l4 2" stroke="#1A1814" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="text-[#1A1814] text-[28px] font-semibold leading-tight">
          Almost there!
        </h1>

        <p className="text-[#1A1814]/60 text-[15px] mt-3.5 leading-relaxed max-w-[300px]">
          Your researcher will assign you to a project soon.
          We'll notify you when you're ready to start.
        </p>

        {userEmail && (
          <p className="text-[#1A1814]/40 text-[13px] mt-6">
            Signed in as {userEmail}
          </p>
        )}

        {onLogout && (
          <button
            onClick={onLogout}
            className="mt-8 text-[#1A1814]/50 text-sm underline"
          >
            Sign out
          </button>
        )}
      </div>
    </div>
  );
};

export default WaitingScreen;
